import { useCallback, useEffect } from 'react';
import { useDispatchApp } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { getGeneralOptions } from 'API/generalOptions/generalOptions';
import { setGeneralOptions } from 'Store';

export const useGeneralOptions = () => {
  const dispatch = useDispatchApp();
  const generalOptions = useAppSelector(
    (generalOptions) => generalOptions.generalOptions.generalOptions
  );

  const initializeGeneralOptions = useCallback(async () => {
    if (!generalOptions) {
      const generalOptionsResult = await getGeneralOptions();
      if (generalOptionsResult) {
        dispatch(setGeneralOptions(generalOptionsResult));
      }
    }
  }, [dispatch, generalOptions]);

  useEffect(() => {
    initializeGeneralOptions();
  }, [initializeGeneralOptions]);

  return generalOptions;
};
